import classNames from 'classnames';
import * as React from 'react';

import styles from './LightComponentBox.less';

interface OwnProps {
  hasScrollbar?: boolean;
  isOverflow?: boolean;
  maxHeight?: boolean;
  className?: string;
  style?: React.CSSProperties;
}
type Props = OwnProps;

export const LightComponentBox: React.FC<Props> = (props) => {
  const {
    children,
    hasScrollbar = false,
    isOverflow = true,
    maxHeight = false,
    className = '',
    ...extraProps
  } = props;
  return (
    <div
      {...extraProps}
      className={classNames({
        [styles.dlCenterVerticalColumn]: true,
        [styles.dlScrollBarPadding]: hasScrollbar,
        [styles.dlOverflow]: isOverflow,
        [styles.dlMaxHeight]: maxHeight,
        [className]: Boolean(className),
      })}
    >
      {children}
    </div>
  );
};

LightComponentBox.displayName = 'LightComponentBox';
